<template>
  <div>
    <ls-table-layout>
      <div slot="search">
        <ls-search-form ref="refSearchForm" @search="onSearch" @reset="onReset" :formList="formList">
          <global-select
            ref="itemCodeListRef"
            slot="itemCodeList"
            :value.sync="queryParams.itemCodeList"
            selectType="selectMultipleSearch"
            :dropdown-match-select-width="false"
            requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
            :selectItem="{ value: 'selectedValue', label: 'label' }"
            searchParam="itemCode"
            sourseField="res"
            :totalNum="9999999999"
          />
          <global-select
            slot="showcaseProjects"
            :value.sync="queryParams.showcaseProjects"
            selectType="selectMultipleFilter"
            :dropdown-match-select-width="false"
            :selectData="projectList"
            :selectItem="{ value: 'realValue', label: 'label' }"
          />
          <a-select slot="suggestionPlaceOrder" v-model="queryParams.suggestionPlaceOrder" allowClear>
            <a-select-option :value="'ltZero'">小于0</a-select-option>
            <a-select-option :value="'eqZero'">等于0</a-select-option>
            <a-select-option :value="'gtZero'">大于0</a-select-option>
          </a-select>
          <global-select
            slot="supplierAddress"
            :value.sync="queryParams.supplierAddress"
            selectType="selectMultipleFilter"
            requestApi="/scp/scpHardwareBoxPlanWork/subInvCombobox"
            :selectItem="{ value: 'realValue', label: 'label' }"
          />
        </ls-search-form>
      </div>
      <div slot="btn">
        <a-space>
          <download-modal :apiFun="apiHardwareBoxPlanWorkExport" ref="download" />
          <a-button type="primary" :loading="btnLoading" :disabled="!isSelect()" @click="handleBatchPlaceOrder">批量下单</a-button>
          <a-button type="primary" :loading="btnLoading" @click="handleExport">导出</a-button>
          <a-button type="primary" :loading="btnLoading" @click="handleSupplyDemand">供需计算</a-button>
          <div class="btn-tip">供需计算最新执行时间：{{ calTime }}</div>
        </a-space>
      </div>
      <div slot="table">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :table-props="tableProps"
          :pagination="pagination"
          rowKey="key_id"
          @successCallBack="handleLoadTableDataFinish"
          :scroll="{x: '100%', fixScreen: true}"
        >
          <template slot="selectionTitle">
            <a-checkbox :checked="allCheck" :indeterminate="indeterminateVal" @change="handleAllSelect" />
          </template>
          <template slot="selection" slot-scope="{ record }">
            <a-checkbox :checked="record.check" @change="(e) => handleSelect(e, record)" />
          </template>
          <!--动态日期-->
<!--          <template v-for="item in qtyColumns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div class="date-data" :key="'hardware-date-val-'+item.dataIndex">
              <span v-if="record.project === 'SUGGESTION_QTY'">
                <a-input-number
                  style="width: 100%"
                  v-model="record[item.dataIndex]"
                  :min="0"
                  :parser="(value) => `${value}`.replace(/\D/g, '')"
                  :formatter="(value) => `${value}`.replace(/\D/g, '')"
                />
              </span>
              <span v-else>{{ record[item.dataIndex] }}</span>
            </div>
          </template>-->
        </ls-api-table>
      </div>
    </ls-table-layout>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import { FRONT_COLUMNS } from '@/views/scp/productionScheduling/hardwarePlanWorkbench/config'
import {
  apiBatchPlaceOrder,
  apiCalculationSupplyDemand,
  apiGetProjectCombobox, apiGetSelectPlanInfo,
  apiHardwareBoxPlanWorkExport,
  apiHardwareBoxPlanWorkPage
} from '@/api/scp/hardwarePlanWorkbench/hardwarePlanWorkbenchApi'

export default {
  name: 'HardwarePlanWorkbench',
  components: { DownloadModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      userName: (state) => state.user.name
    })
  },
  data () {
    return {
      getTime: undefined, // 供需计算最新执行时间的定时器
      calTime: '', // 供需计算最新执行时间
      version: '', // 计算版本号
      btnLoading: false,
      indeterminateVal: false,
      allCheck: false,
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      projectList: [],
      apiHardwareBoxPlanWorkExport,
      formList: [
        { label: '物料编码', decorator: ['itemCodeList'], type: 'itemCodeList' },
        { label: '展开项目', decorator: ['showcaseProjects'], type: 'showcaseProjects' },
        { label: '建议下单', decorator: ['suggestionPlaceOrder'], type: 'suggestionPlaceOrder' },
        { label: '配送地', decorator: ['supplierAddress'], type: 'supplierAddress' }
      ],
      frontColumns: FRONT_COLUMNS(this.renderCell),
      qtyColumns: [],
      columns: [],
      tableProps: {
        requestApi: generateLsTableResData(apiHardwareBoxPlanWorkPage, true)
      },
      pagination: {
        total: 0,
        pageSize: 60,
        current: 1,
        pageSizeOptions: ['60', '120', '300']
      },
      queryParams: {
        showcaseProjects: [],
        suggestionPlaceOrder: '',
        supplierAddress: [],
        itemCodeList: []
      }
    }
  },
  created () {
    this.initGetProject()
    this.searchToSetTittle() // 设置表头
    this.getPlanInfo()
  },
  mounted () {
    this.version = ''
    this.onSearch()
  },
  beforeDestroy () {
    this.getTime = undefined // 清除定时器
  },
  methods: {
    // 查询计划执行信息
    getPlanInfo() {
      this.calTime = ''
      apiGetSelectPlanInfo({}).then(res => {
        if(res?.code === 200) {
          if(res?.data?.endTime) {
            this.calTime = this.$moment(res.data.endTime).format('YYYY-MM-DD HH:mm')
          }
          this.version = res?.data?.version
        }
      })
    },
    // 轮询查询计划执行时间，轮询时间为1分钟
    getTimeInterval() {
      const self = this
      self.getPlanInfo()
      self.getTime = setInterval(() => {
        self.getPlanInfo();
      }, 1000 * 60 * 1);
    },
    isSelect() {
      if(this.$refs?.dataTable?.myDataSource) {
        return this.$refs.dataTable.myDataSource.filter(item => item.check).length > 0
      }
      return false
    },
    initGetProject() {
      this.projectList = []
      apiGetProjectCombobox({}).then(res => {
        if(res?.code === 200 && res?.data?.length > 0) {
          this.projectList = res.data
        }
      })
    },
    // 部分选状态判断
    indeterminateFun() {
      this.$nextTick(() => {
        if (!this.$refs?.dataTable || !this.$refs.dataTable.myDataSource || this.$refs?.dataTable?.myDataSource?.length < 1) {
          this.indeterminateVal = false
          return
        }
        const dataList = this.$refs.dataTable.myDataSource
        if (dataList.every(item => item.check === true) || dataList.every(item => item.check === false)) {
          this.indeterminateVal = false;
          return
        }
        this.indeterminateVal = true
      })
    },
    // 全选
    handleAllSelect() {
      this.allCheck = !this.allCheck
      this.changeAllSelect(this.allCheck);
    },
    // 改动全选
    changeAllSelect(checkVal) {
      if(this.$refs?.dataTable?.myDataSource?.length > 0) {
        this.$refs.dataTable.myDataSource.forEach((item, index) => {
          this.$set(this.$refs.dataTable.myDataSource[index], 'check', checkVal)
        })
      }
      this.indeterminateFun()
    },
    // 单选
    handleSelect(e, record) {
      record.check = !record.check
      this.$refs.dataTable.myDataSource.forEach((item, index) => {
        // 实际根据加工厂编码和物料编码都相同合并的的同时，也把勾选的数据状态也一起修改
        if(item.supplierCode === record.supplierCode && item.itemCode === record.itemCode) {
          this.$set(this.$refs.dataTable.myDataSource[index], 'check', record.check)
        }
      })
      // 检查全选
      this.allCheck = this.$refs.dataTable.myDataSource.every(item => item.check === true)
      this.indeterminateFun()
    },
    // 重新查询一次，获取到数据后，设置表头
    searchToSetTittle() {
      const paramsVal = {
        pageNum: 1,
        pageSize: 20
      }
      const dateColumn = []
      this.qtyColumns = []
      apiHardwareBoxPlanWorkPage(paramsVal).then(res => {
        if(res?.code === 200 && res?.titleList?.length > 0) {
          // 日期和qty顺序一一对应
          res.titleList.forEach((item, index) => {
            dateColumn.push({
              title: item,
              dataIndex: `qty${index + 1}`,
              align: 'center',
              // scopedSlots: { customRender: `qty${index + 1}` },
              width: 100
            })
          })
          this.qtyColumns = dateColumn
          this.columns = this.frontColumns.concat(this.qtyColumns)
        }
      })
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    onSearch (value = {}, changePage = false) {
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel;
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData(changePage);
    },
    // 批量下单
    handleBatchPlaceOrder() {
      const listData = this.$refs?.dataTable?.myDataSource || []
      const selectData = listData.filter(item => item.check)
      if(selectData?.length < 1) {
        this.$message.warning('请选择数据下单')
        return
      }
      if(!this.version) {
        this.$message.warning('版本为空，请先执行供需计算')
        return
      }
      const idList = selectData.map(item => item.id)
      const uniqueIdList = [...new Set(idList)];
      const params = {
        boxIdList: uniqueIdList,
        version: this.version,
        allFlag: this.allCheck
      }
      this.btnLoading = true
      apiBatchPlaceOrder(params).then(res => {
        if(res?.code === 200) {
         this.$message.success('批量下单成功')
          this.handleOk(false)
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 供需计算
    handleSupplyDemand() {
      const self = this
      self.$confirm({
        title: '提示',
        content: '请确认是否执行供需计算？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.btnLoading = true
          apiCalculationSupplyDemand([]).then(res => {
            if(res?.code === 200) {
              self.$message.success('执行计算成功')
              self.handleOk(false)
              self.getTimeInterval()
            }
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    },
    // 导出
    handleExport () {
      this.$message.loading('导出中，请稍等..', 2)
      const params = {
        ...this.$refs.dataTable.searchParams
      }
      delete params.searchFormLabel;
      this.$refs.download.openModal(params)
    },
    // 列表加载完成
    handleLoadTableDataFinish (data) {
      this.changeAllSelect(false);
    },
    // 合并单元格，dataIndexArray判断合并单元格的依据
    renderCell (value, row, index, dataIndexArray, isSelect) {
      const dataSource = this.$refs.dataTable.myDataSource;
      const currentValues = dataIndexArray.map(dataIndex => row[dataIndex]);
      const prevRow = index > 0 ? dataIndexArray.map(dataIndex => dataSource[index - 1][dataIndex]) : null;
      const obj = { children: value, attrs: {} };
      if(isSelect) {
        obj.children = <a-checkbox checked={!!row.check} onChange={(e) => this.handleSelect(e, row)}></a-checkbox>
      }

      // 判断当前行的值与前一行是否相同，如果相同，则合并单元格
      if (prevRow && prevRow.every((prevValue, i) => prevValue === currentValues[i])) {
        obj.attrs.rowSpan = 0;
      } else {
        // 计算相同值出现的次数，设置 rowSpan
        let rowSpan = 1;
        for (let i = index + 1; i < dataSource.length; i++) {
          const nextValues = dataIndexArray.map(dataIndex => dataSource[i][dataIndex]);
          if (nextValues.every((nextValue, j) => nextValue === currentValues[j])) {
            rowSpan++;
          } else {
            break;
          }
        }
        obj.attrs.rowSpan = rowSpan;
      }
      return obj;
    },
    onReset () {
      this.queryParams = {
        showcaseProjects: [],
        suggestionPlaceOrder: '',
        supplierAddress: [],
        itemCodeList: []
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.itemCodeListRef.handleSearch('');
    }
  }
}
</script>

<style scoped lang="less">
.btn-tip{
  margin: 10px 0 0 10px;
}
</style>
